import React, { useEffect, useRef } from 'react';
import './AdBanner.css';

// Google AdSense publisher for satoshiadvance.com (matches the root ads.txt).
const AD_CLIENT = 'ca-pub-1837036543658433';

// TODO: replace with the real slot ID after creating a Display ad unit in
// AdSense (Ads -> By ad unit -> Display ad -> e.g. "Bit Wheel bottom banner").
// Ads will not serve until this is a real slot number.
const AD_SLOT = '0000000000';

// One small responsive banner. Renders nothing in local dev (AdSense rejects
// localhost and would just log errors), and reserves height in production to
// avoid layout shift when the ad loads.
const AdBanner = () => {
  const insRef = useRef(null);

  const isLocal =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  useEffect(() => {
    if (isLocal || AD_SLOT === '0000000000') {
      return;
    }
    // Guard against double-push on remounts: AdSense stamps the <ins> once filled.
    const ins = insRef.current;
    if (!ins || ins.getAttribute('data-adsbygoogle-status')) {
      return;
    }
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.log('AdSense error:', error);
    }
  }, [isLocal]);

  if (isLocal || AD_SLOT === '0000000000') {
    return null;
  }

  return (
    <div className="ad-banner">
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="horizontal"
        data-full-width-responsive="false"
      />
    </div>
  );
};

export default AdBanner;
